import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  userInfoArea: {
    textAlign: "center",
    marginBottom: theme.spacing(4),
    height: "7em",
  },
  branchBox: {
    margin: theme.spacing(2),
    position: "absolute",
    width: "16%",
    left: "0%",
  },
  accountBox: {
    margin: theme.spacing(2),
    position: "absolute",
    width: "16%",
    left: "20%",
  },
  cifBox: {
    margin: theme.spacing(2),
    position: "absolute",
    width: "16%",
    left: "40%",
  },
  nameBox: {
    margin: theme.spacing(2),
    position: "absolute",
    width: "16%",
    left: "60%",
  },
  spanBox: {
    margin: theme.spacing(2),
    position: "absolute",
    width: "16%",
    left: "80%",
  },
}));

export default function AccountInfoArea(props) {
  const classes = useStyles();
  const { branchCode, accountNumber, cifNo, name, span, handleChangeSpan } =
    props;

  return (
    <>
      <div style={{ marginTop: "40px" }}></div>
      <Paper elevation={0} className={classes.userInfoArea}>
        <div class="row">
          <div class="col-xs-1" />
          <div class="col-xs-2">
            <TextField
              disabled
              id="filled-read-only-branch-code"
              label="店番号"
              defaultValue={branchCode}
              variant="outlined"
            />
          </div>
          <div class="col-xs-2">
            <TextField
              disabled
              id="filled-read-only-account-number"
              label="口座番号"
              defaultValue={accountNumber}
              variant="outlined"
            />
          </div>
          <div class="col-xs-2">
            <TextField
              disabled
              id="filled-read-only-cif"
              label="CIF番号"
              defaultValue={cifNo}
              variant="outlined"
            />
          </div>
          <div class="col-xs-2">
            <TextField
              disabled
              id="filled-read-only-name"
              label="氏名"
              defaultValue={name}
              variant="outlined"
            />
          </div>
          <div class="col-xs-2">
            <TextField
              id="filled-span"
              label="日数"
              value={span}
              variant="outlined"
              onChange={handleChangeSpan}
            />
          </div>
        </div>
      </Paper>
    </>
  );
}
